class DrStickyCart {
  constructor() {
    this.container = document.getElementById('dr-sticky-cart');
    if (!this.container) return;
    
    this.button = this.container.querySelector('.dr-StickyCart__button');
    if (!this.button) return;

    this.header = document.querySelector('header') || document.querySelector('.section-header');
    this.isHeaderVisible = true;

    this.bindEvents();
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    if (!this.header) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.isHeaderVisible = entry.isIntersecting;
        this.updateVisibility();
      });
    }, {
      rootMargin: '100px 0px 0px 0px', 
      threshold: 0
    });

    observer.observe(this.header);
  }

  updateVisibility() {
    if (this.isHeaderVisible) {
      this.container.classList.add('dr-StickyCart--hidden-by-header');
    } else {
      this.container.classList.remove('dr-StickyCart--hidden-by-header');
    }
  }

  bindEvents() {
    // Open cart drawer on click
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(this.button);
      }
    });

    // Listen to cart updates to show/hide the button
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData && typeof event.cartData.item_count !== 'undefined') {
          const itemCount = event.cartData.item_count;
          const bubble = this.container.querySelector('.dr-StickyCart__count-bubble');
          const bubbleSpan = bubble ? bubble.querySelector('span') : null;

          if (itemCount > 0) {
            this.container.classList.remove('dr-StickyCart--empty');
            if (bubble) bubble.classList.remove('hidden');
            if (bubbleSpan) bubbleSpan.textContent = itemCount;
          } else {
            this.container.classList.add('dr-StickyCart--empty');
            if (bubble) bubble.classList.add('hidden');
            if (bubbleSpan) bubbleSpan.textContent = '0';
          }
        }
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new DrStickyCart());
} else {
  new DrStickyCart();
}